/* eslint-disable prettier/prettier */ /**
 * Do not edit directly
 * Generated on Fri, 25 Apr 2025 08:51:03 GMT
 */
const BACKGROUND_COLOR_CLASS = Object.freeze({
    Neutral10: "qui-background-color-neutral-10",
    Neutral20: "qui-background-color-neutral-20",
    Neutral30: "qui-background-color-neutral-30",
    Neutral40: "qui-background-color-neutral-40",
    Neutral50: "qui-background-color-neutral-50",
    Neutral60: "qui-background-color-neutral-60",
    Neutral70: "qui-background-color-neutral-70",
    Neutral80: "qui-background-color-neutral-80",
    Neutral90: "qui-background-color-neutral-90",
    Neutral92: "qui-background-color-neutral-92",
    Neutral94: "qui-background-color-neutral-94",
    Neutral96: "qui-background-color-neutral-96",
    Neutral98: "qui-background-color-neutral-98",
    NeutralBlack: "qui-background-color-neutral-black",
    NeutralWhite: "qui-background-color-neutral-white",
    Petrol10: "qui-background-color-petrol-10",
    Petrol20: "qui-background-color-petrol-20",
    Petrol30: "qui-background-color-petrol-30",
    Petrol40: "qui-background-color-petrol-40",
    Petrol50: "qui-background-color-petrol-50",
    Petrol60: "qui-background-color-petrol-60",
    Petrol70: "qui-background-color-petrol-70",
    Petrol80: "qui-background-color-petrol-80",
    Petrol90: "qui-background-color-petrol-90",
    Petrol98: "qui-background-color-petrol-98",
    Pink10: "qui-background-color-pink-10",
    Pink20: "qui-background-color-pink-20",
    Pink30: "qui-background-color-pink-30",
    Pink40: "qui-background-color-pink-40",
    Pink50: "qui-background-color-pink-50",
    Pink60: "qui-background-color-pink-60",
    Pink70: "qui-background-color-pink-70",
    Pink80: "qui-background-color-pink-80",
    Pink90: "qui-background-color-pink-90",
    Pink98: "qui-background-color-pink-98",
    Red10: "qui-background-color-red-10",
    Red20: "qui-background-color-red-20",
    Red30: "qui-background-color-red-30",
    Red40: "qui-background-color-red-40",
    Red50: "qui-background-color-red-50",
    Red60: "qui-background-color-red-60",
    Red70: "qui-background-color-red-70",
    Red80: "qui-background-color-red-80",
    Red90: "qui-background-color-red-90",
    Red98: "qui-background-color-red-98",
    Yellow10: "qui-background-color-yellow-10",
    Yellow20: "qui-background-color-yellow-20",
    Yellow30: "qui-background-color-yellow-30",
    Yellow40: "qui-background-color-yellow-40",
    Yellow50: "qui-background-color-yellow-50",
    Yellow60: "qui-background-color-yellow-60",
    Yellow70: "qui-background-color-yellow-70",
    Yellow80: "qui-background-color-yellow-80",
    Yellow90: "qui-background-color-yellow-90",
    Yellow98: "qui-background-color-yellow-98",
    Green10: "qui-background-color-green-10",
    Green20: "qui-background-color-green-20",
    Green30: "qui-background-color-green-30",
    Green40: "qui-background-color-green-40",
    Green50: "qui-background-color-green-50",
    Green60: "qui-background-color-green-60",
    Green70: "qui-background-color-green-70",
    Green80: "qui-background-color-green-80",
    Green90: "qui-background-color-green-90",
    Green98: "qui-background-color-green-98",
    Pumpkin10: "qui-background-color-pumpkin-10",
    Pumpkin20: "qui-background-color-pumpkin-20",
    Pumpkin30: "qui-background-color-pumpkin-30",
    Pumpkin40: "qui-background-color-pumpkin-40",
    Pumpkin50: "qui-background-color-pumpkin-50",
    Pumpkin60: "qui-background-color-pumpkin-60",
    Pumpkin70: "qui-background-color-pumpkin-70",
    Pumpkin80: "qui-background-color-pumpkin-80",
    Pumpkin90: "qui-background-color-pumpkin-90",
    Pumpkin98: "qui-background-color-pumpkin-98",
    Flamingo10: "qui-background-color-flamingo-10",
    Flamingo20: "qui-background-color-flamingo-20",
    Flamingo30: "qui-background-color-flamingo-30",
    Flamingo40: "qui-background-color-flamingo-40",
    Flamingo50: "qui-background-color-flamingo-50",
    Flamingo60: "qui-background-color-flamingo-60",
    Flamingo70: "qui-background-color-flamingo-70",
    Flamingo80: "qui-background-color-flamingo-80",
    Flamingo90: "qui-background-color-flamingo-90",
    Flamingo98: "qui-background-color-flamingo-98",
    Night10: "qui-background-color-night-10",
    Night20: "qui-background-color-night-20",
    Night30: "qui-background-color-night-30",
    Night40: "qui-background-color-night-40",
    Night50: "qui-background-color-night-50",
    Night60: "qui-background-color-night-60",
    Night70: "qui-background-color-night-70",
    Night80: "qui-background-color-night-80",
    Night90: "qui-background-color-night-90",
    Night98: "qui-background-color-night-98",
    Ocean10: "qui-background-color-ocean-10",
    Ocean20: "qui-background-color-ocean-20",
    Ocean30: "qui-background-color-ocean-30",
    Ocean40: "qui-background-color-ocean-40",
    Ocean50: "qui-background-color-ocean-50",
    Ocean60: "qui-background-color-ocean-60",
    Ocean70: "qui-background-color-ocean-70",
    Ocean80: "qui-background-color-ocean-80",
    Ocean90: "qui-background-color-ocean-90",
    Ocean98: "qui-background-color-ocean-98",
    Monsoon10: "qui-background-color-monsoon-10",
    Monsoon20: "qui-background-color-monsoon-20",
    Monsoon30: "qui-background-color-monsoon-30",
    Monsoon40: "qui-background-color-monsoon-40",
    Monsoon50: "qui-background-color-monsoon-50",
    Monsoon60: "qui-background-color-monsoon-60",
    Monsoon70: "qui-background-color-monsoon-70",
    Monsoon80: "qui-background-color-monsoon-80",
    Monsoon90: "qui-background-color-monsoon-90",
    Monsoon98: "qui-background-color-monsoon-98",
    Violet10: "qui-background-color-violet-10",
    Violet20: "qui-background-color-violet-20",
    Violet30: "qui-background-color-violet-30",
    Violet40: "qui-background-color-violet-40",
    Violet50: "qui-background-color-violet-50",
    Violet60: "qui-background-color-violet-60",
    Violet70: "qui-background-color-violet-70",
    Violet80: "qui-background-color-violet-80",
    Violet90: "qui-background-color-violet-90",
    Violet98: "qui-background-color-violet-98",
    Blue10: "qui-background-color-blue-10",
    Blue20: "qui-background-color-blue-20",
    Blue30: "qui-background-color-blue-30",
    Blue40: "qui-background-color-blue-40",
    Blue50: "qui-background-color-blue-50",
    Blue60: "qui-background-color-blue-60",
    Blue70: "qui-background-color-blue-70",
    Blue80: "qui-background-color-blue-80",
    Blue90: "qui-background-color-blue-90",
    Blue98: "qui-background-color-blue-98",
    PrimaryMain: "qui-background-color-primary-main",
    PrimaryAlt: "qui-background-color-primary-alt",
    PrimaryAltOverlay: "qui-background-color-primary-alt-overlay",
    PrimaryMainOverlay: "qui-background-color-primary-main-overlay",
    SecondaryMain: "qui-background-color-secondary-main",
    SecondaryAlt: "qui-background-color-secondary-alt",
    SecondaryMainOverlay: "qui-background-color-secondary-main-overlay",
    SecondaryAltOverlay: "qui-background-color-secondary-alt-overlay",
    SurfaceMain: "qui-background-color-surface-main",
    SurfaceContrastMid: "qui-background-color-surface-contrast-mid",
    SurfaceContrastLeast: "qui-background-color-surface-contrast-least",
    SurfaceContrastLow: "qui-background-color-surface-contrast-low",
    SurfaceContrastHigh: "qui-background-color-surface-contrast-high",
    SurfaceContrastMost: "qui-background-color-surface-contrast-most",
    SurfaceOutline: "qui-background-color-surface-outline",
    SurfaceOverlay: "qui-background-color-surface-overlay",
    DangerMain: "qui-background-color-danger-main",
    DangerAlt: "qui-background-color-danger-alt",
    DangerAltOverlay: "qui-background-color-danger-alt-overlay",
    DangerMainOverlay: "qui-background-color-danger-main-overlay",
    WarningMain: "qui-background-color-warning-main",
    WarningAlt: "qui-background-color-warning-alt",
    WarningAltOverlay: "qui-background-color-warning-alt-overlay",
    WarningMainOverlay: "qui-background-color-warning-main-overlay",
    SuccessMain: "qui-background-color-success-main",
    SuccessAlt: "qui-background-color-success-alt",
    SuccessAltOverlay: "qui-background-color-success-alt-overlay",
    SuccessMainOverlay: "qui-background-color-success-main-overlay",
    DisabledOverlay: "qui-background-color-disabled-overlay",
    DisabledOverlayStrong: "qui-background-color-disabled-overlay-strong",
    MiscScrim: "qui-background-color-misc-scrim",
    MiscLink: "qui-background-color-misc-link",
    NeutralAlt: "qui-background-color-neutral-alt",
    NeutralMain: "qui-background-color-neutral-main",
    DisplayGreenMain: "qui-background-color-display-green-main",
    DisplayGreenMainOverlay: "qui-background-color-display-green-main-overlay",
    DisplayGreenAlt: "qui-background-color-display-green-alt",
    DisplayGreenAltOverlay: "qui-background-color-display-green-alt-overlay",
    DisplayYellowMain: "qui-background-color-display-yellow-main",
    DisplayYellowMainOverlay: "qui-background-color-display-yellow-main-overlay",
    DisplayYellowAlt: "qui-background-color-display-yellow-alt",
    DisplayYellowAltOverlay: "qui-background-color-display-yellow-alt-overlay",
    DisplayRedMain: "qui-background-color-display-red-main",
    DisplayRedMainOverlay: "qui-background-color-display-red-main-overlay",
    DisplayRedAlt: "qui-background-color-display-red-alt",
    DisplayRedAltOverlay: "qui-background-color-display-red-alt-overlay",
    DisplayPumpkinMain: "qui-background-color-display-pumpkin-main",
    DisplayPumpkinMainOverlay: "qui-background-color-display-pumpkin-main-overlay",
    DisplayPumpkinAlt: "qui-background-color-display-pumpkin-alt",
    DisplayPumpkinAltOverlay: "qui-background-color-display-pumpkin-alt-overlay",
    DisplayFlamingoMain: "qui-background-color-display-flamingo-main",
    DisplayFlamingoMainOverlay: "qui-background-color-display-flamingo-main-overlay",
    DisplayFlamingoAlt: "qui-background-color-display-flamingo-alt",
    DisplayFlamingoAltOverlay: "qui-background-color-display-flamingo-alt-overlay",
    DisplayVioletMain: "qui-background-color-display-violet-main",
    DisplayVioletMainOverlay: "qui-background-color-display-violet-main-overlay",
    DisplayVioletAlt: "qui-background-color-display-violet-alt",
    DisplayVioletAltOverlay: "qui-background-color-display-violet-alt-overlay",
    DisplayNightMain: "qui-background-color-display-night-main",
    DisplayNightMainOverlay: "qui-background-color-display-night-main-overlay",
    DisplayNightAlt: "qui-background-color-display-night-alt",
    DisplayNightAltOverlay: "qui-background-color-display-night-alt-overlay",
    DisplayOceanMain: "qui-background-color-display-ocean-main",
    DisplayOceanMainOverlay: "qui-background-color-display-ocean-main-overlay",
    DisplayOceanAlt: "qui-background-color-display-ocean-alt",
    DisplayOceanAltOverlay: "qui-background-color-display-ocean-alt-overlay",
    DisplayMonsoonMain: "qui-background-color-display-monsoon-main",
    DisplayMonsoonMainOverlay: "qui-background-color-display-monsoon-main-overlay",
    DisplayMonsoonAlt: "qui-background-color-display-monsoon-alt",
    DisplayMonsoonAltOverlay: "qui-background-color-display-monsoon-alt-overlay",
    InfoMain: "qui-background-color-info-main",
    InfoMainOverlay: "qui-background-color-info-main-overlay",
    InfoAlt: "qui-background-color-info-alt",
    InfoAltOverlay: "qui-background-color-info-alt-overlay",
});

export { BACKGROUND_COLOR_CLASS };
